<template>
  <div class="user-row">
    <div>
      <div class="user">
        <router-link :to="route" class="name">{{ fullName }}</router-link>
        <div :class="statusClassList" class="status">{{ statusText }}</div>
      </div>
      <div class="contact">
        <div class="phone-number">
          <div class="label">เบอร์โทรศัพท์</div>
          <div>
            <a
              v-if="phoneNumber"
              :href="`callto://${phoneNumber}`"
              class="callto-link"
            >
              {{ phoneNumber }}
            </a>
            <span v-else>-</span>
          </div>
        </div>
        <div class="email">
          <div class="label">อีเมล</div>
          <div class="value">{{ email || "-" }}</div>
        </div>
      </div>
      <div v-if="home" class="home">
        <div class="header">บ้านหลัก</div>
        <div class="data">
          <div class="status">
            <div class="label">ฐานะ</div>
            <div class="value">{{ userRole }}</div>
          </div>
          <div class="address">
            <div class="label">บ้านเลขที่</div>
            <div class="value">{{ home.addressNumber }}</div>
          </div>
          <div class="project">
            <div class="label">โครงการ</div>
            <div class="value">{{ home.projectName }}</div>
          </div>
        </div>
      </div>
    </div>

    <RueJaiChatButton :id="id" :is-support-rue-jai-chat="isSupportRueJaiChat" />
  </div>
</template>

<script>
import { userRoleMapper } from "@/lib/mapper"
import RueJaiChatButton from "./RueJaiChatButton"

export default {
  components: {
    RueJaiChatButton,
  },
  props: {
    route: {
      type: null,
      default: undefined,
    },
    firstName: {
      type: null,
      default: undefined,
    },
    lastName: {
      type: null,
      default: undefined,
    },
    identifierId: {
      type: null,
      default: undefined,
    },
    phoneNumber: {
      type: null,
      default: undefined,
    },
    email: {
      type: null,
      default: undefined,
    },
    isVerified: {
      type: null,
      default: undefined,
    },
    home: {
      type: null,
      default: undefined,
    },
    isSupportRueJaiChat: {
      type: null,
      default: undefined,
    },
    id: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    fullName() {
      return `${this.firstName} ${this.lastName}`
    },
    statusText() {
      if (!this.isVerified) {
        return "ยังไม่ยืนยันตัวตน"
      }

      return "ยืนยันตัวตนแล้ว"
    },
    statusClassList() {
      if (!this.isVerified) {
        return ""
      }

      return "verified"
    },
    userRole() {
      if (!this.home) {
        return ""
      }

      return userRoleMapper[this.home.userRole]
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.name {
  font-weight: bold;
}

.contact,
.home {
  margin-top: 15px;
}

.contact {
  display: grid;
  grid-template-columns: 180px 120px auto;
  grid-gap: 15px;
}

.home > .data {
  display: grid;
  grid-template-columns: 120px 120px auto;
  grid-gap: 15px;
}

.label {
  color: #777;
  font-size: 0.9rem;
}

.user > .status {
  color: $danger-color;
  font-size: 0.9rem;
  font-weight: bold;

  &.verified {
    color: $success-color;
  }
}

.home > .header {
  font-size: 0.9rem;
  font-weight: bold;
}

.callto-link {
  color: $blue;
  text-decoration: underline;
  &:hover {
    font-weight: bold;
  }
}
</style>
